<section class="payment-page">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">

        <h2 class="mb-3">Complete Your Payment</h2>

        <!-- Trip amount -->
        <div class="amount-summary mb-4">
          <div class="amount-row">
            <span>Trip Amount</span>
            <span class="amount-value">${{subtotal.toFixed(2)}}</span>
          </div>
        </div>

        <!-- Zip code for Stripe Tax -->
        <div class="form-group zip-group mb-3">
          <label class="zip-label">
            <span>Billing Zip Code <span class="required-star">*</span></span>
            <span class="stripe-tax-badge">Stripe Tax</span>
          </label>
          <div class="zip-input-wrapper">
            <input type="text" class="form-control zip-input" maxlength="10"
                   placeholder="Enter zip code to continue"
                   [value]="zipCode"
                   [disabled]="taxCalculating"
                    (keyup)="onZipChange($any($event.target).value)">
            <span class="zip-loading" *ngIf="taxCalculating">
              <mat-spinner diameter="18"></mat-spinner>
            </span>
          </div>
        </div>

        <!-- Tax error -->
        <div class="alert alert-warning d-flex align-items-center gap-2" *ngIf="taxError">
          <mat-icon>warning</mat-icon>
          <span>{{taxError}}</span>
        </div>

        <!-- Tax breakdown -->
        <div class="tax-breakdown" *ngIf="taxEstimated">
          <div class="tax-row">
            <span>Subtotal</span>
            <span>${{subtotal.toFixed(2)}}</span>
          </div>
          <div class="tax-row">
            <span>
              Est. Sales Tax ({{taxPercent}}%)
              <span class="tax-jurisdiction" *ngIf="taxBreakdown?.jurisdiction">
                &mdash; {{taxBreakdown.jurisdiction}}
              </span>
            </span>
            <span>${{taxAmount.toFixed(2)}}</span>
          </div>
          <div class="tax-row total-row">
            <span>Total</span>
            <span>${{total.toFixed(2)}}</span>
          </div>
        </div>

        <!-- Stripe payment element -->
        <!-- Always in DOM so Stripe can mount; hidden until zip validated -->
        <div class="form-group mb-3" [class.d-none]="!stripeReady">
          <div id="payment-element" class="stripe-element-container"></div>
        </div>

        <!-- Hint shown before zip is validated -->
        <div class="zip-hint mb-3" *ngIf="!stripeReady && !taxCalculating">
          <mat-icon>lock</mat-icon>
          <small>Enter your billing zip code above to load payment options.</small>
        </div>

        <!-- Pay button -->
        <button mat-raised-button class="submit w-100 mt-3"
                [disabled]="isProcessing || !stripeReady || taxCalculating || !zipValidated"
                (click)="pay()">
          <mat-spinner diameter="20" *ngIf="isProcessing" class="btn-spinner"></mat-spinner>
          <span *ngIf="!isProcessing && mode === 'new_booking'">Confirm Booking &mdash; ${{(taxEstimated ? total : subtotal).toFixed(2)}}</span>
          <span *ngIf="!isProcessing && mode === 'existing_trip'">Pay ${{(taxEstimated ? total : subtotal).toFixed(2)}}</span>
          <span *ngIf="isProcessing">Processing&hellip;</span>
        </button>

        <!-- Billing terms: when the card will be charged -->
        <div class="billing-terms mt-3" *ngIf="mode === 'new_booking'">
          <mat-icon>event_available</mat-icon>
          <div>
            <strong>You will not be charged today.</strong>
            <small class="d-block">
              Your card is saved securely when you confirm this booking. The trip total, including applicable taxes,
              will be charged to this card once your ride is completed. The final amount may differ from this estimate
              if your trip changes (for example, added stops, wait time or a different route). By confirming, you
              authorize us to charge this card for the completed trip in accordance with our
              <a routerLink="/terms-conditions" target="_blank">Terms &amp; Conditions</a> and
              <a href="https://yodertoter.com/docs/privacy.html#refunds" target="_blank" rel="noopener">Refund &amp; Cancellation Policy</a>.
            </small>
          </div>
        </div>
        <div class="billing-terms mt-3" *ngIf="mode === 'existing_trip'">
          <mat-icon>credit_card</mat-icon>
          <div>
            <strong>Your card will be charged immediately.</strong>
            <small class="d-block">
              Clicking Pay charges the amount shown above to your card right away. See our
              <a routerLink="/terms-conditions" target="_blank">Terms &amp; Conditions</a> and
              <a href="https://yodertoter.com/docs/privacy.html#refunds" target="_blank" rel="noopener">Refund &amp; Cancellation Policy</a>.
            </small>
          </div>
        </div>

        <!-- Tax notice -->
        <div class="tax-notice mt-2" *ngIf="taxEstimated">
          <mat-icon>info</mat-icon>
          <small>Tax calculated via Stripe Tax API. Actual amount may vary based on your location.</small>
        </div>

        <!-- Security notice -->
        <div class="security-notice mt-3">
          <mat-icon>lock</mat-icon>
          <small>Your payment information is secure and encrypted. We never store your full card or bank details.</small>
        </div>

      </div>
    </div>
  </div>
</section>
